export const isSystemRoleName = (roleName?: string): boolean => {
  const role = (roleName ?? '').trim();
  if (!role) return false;
  // Current UI uses role display names like "System Engineer" / "System Leader".
  return /system/i.test(role);
};

export const canUseTkTune = (args: { isAdmin?: boolean; roleName?: string }): boolean => {
  return Boolean(args.isAdmin) || isSystemRoleName(args.roleName);
};

